/*
  Umkreissuche des Installateursportals.

  Ruft aus dem Browser zwei Funktionen in Supabase auf:
    betriebe_im_umkreis_v3(p_plz, p_km)  — Treffer im Umkreis (mit Handwerkskarte, Änderungsauftrag 2)
    betriebe_naechste_v3(p_plz, p_anzahl) — die naechsten Betriebe ueberhaupt,
                                            fuer den Leerzustand
  Beide sind versioniert und duerfen sich nicht aendern (Bauplan 4.8): diese
  Datei liegt im veroeffentlichten Theme, eine Signaturaenderung braeche die
  Seite stillschweigend.

  Adresse und oeffentlicher Schluessel stehen in den Theme-Einstellungen und
  kommen als data-Attribute an der Section an. Der Dienstschluessel taucht hier
  nie auf.

  Treffer oder Leerzustand. Eine offene Anfrage an SolarOutlet gibt es nicht
  mehr (Michel 21.09.2026); der Leerzustand zeigt die naechsten Betriebe
  ausserhalb des Radius mit ehrlicher Entfernung.
*/
(function () {
  'use strict';

  var GEWERKE = {
    pv_aufdach: 'Aufdachanlagen',
    pv_flachdach: 'Flachdachanlagen',
    speicher: 'Speicher',
    wallbox: 'Wallboxen',
    waermepumpe: 'Wärmepumpen',
    elektroinstallation: 'Elektroinstallation',
    netzanmeldung: 'Netzanmeldung',
    wartung: 'Wartung'
  };

  function esc(t) {
    return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // Wie snippets/installateur-stufe.liquid (Änderungsauftrag 2, 7.3)
  var ERKL = 'Wir haben abgeglichen, dass es dieses Unternehmen an diesem Ort gibt. Die Qualität der Arbeit können wir nicht bewerten.';
  function stufe(handwerkskarte) {
    var siegel = '<svg class="inst-abzeichen__schild" viewBox="0 0 20 23" width="14" height="16" aria-hidden="true"><defs><linearGradient id="inst-schild-verlauf" x1="-2.22" y1="-5.75" x2="28.55" y2="23.93" gradientUnits="userSpaceOnUse"><stop stop-color="#7AFF7E"/><stop offset="1" stop-color="#fff"/></linearGradient></defs><path d="M0 9.68C0 6 0 4.16.42 3.54.84 2.93 2.51 2.33 5.85 1.15l.64-.23C8.23.31 9.1 0 10 0s1.77.31 3.51.93l.64.22c3.34 1.18 5.01 1.78 5.43 2.39.42.62.42 2.46.42 6.14v1.81c0 6.48-4.71 9.63-7.67 10.97-.8.36-1.2.54-2.33.54s-1.53-.18-2.33-.54C4.71 21.12 0 17.97 0 11.49V9.68z" fill="url(#inst-schild-verlauf)"/><path d="M6 12.1l2.29 2.4L14 8.5" fill="none" stroke="#003339" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    return '<span class="inst-stufe"><details class="inst-verifiziert"><summary class="inst-abzeichen" aria-label="Verifiziert, Erklärung anzeigen">' + siegel +
      '<span class="inst-abzeichen__text">verifiziert</span><svg class="inst-verifiziert__i" viewBox="0 0 21.5 21.5" width="14" height="14" fill="none" aria-hidden="true"><path d="M3.68 17.82A10 10 0 1 1 17.82 3.68 10 10 0 0 1 3.68 17.82Z" stroke="currentColor" stroke-width="1.5"/><path d="M10.75 15.75v-6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><circle cx="10.75" cy="6.75" r="1" fill="currentColor"/></svg></summary><span class="inst-verifiziert__text">' + ERKL + '</span></details>' +
      '</span>'; // Handwerkskarte nur im Profil unter "Nachweise" (Michel 21.09.2026)
  }
  var SORTIERHINWEIS = '<p class="inst-sortierhinweis">Sortiert nach Entfernung. Bei ähnlicher Entfernung stehen Betriebe vorn, deren Handwerkskarte uns vorliegt. Kein Betrieb zahlt für seine Platzierung.</p>';

  // Dieselben Klassen wie snippets/installateur-karte.liquid, damit gerenderte
  // und nachgeladene Karten gleich aussehen.
  // Anfragen an einen bestimmten Betrieb laufen immer ueber dessen Seite
  // (Entscheidung Michel 21.09.2026). Die Postleitzahl reist mit.
  function profilAdresse(b, plz) {
    return '/pages/installateure/' + encodeURIComponent(b.handle) + (plz ? '?plz=' + encodeURIComponent(plz) : '');
  }

  function karte(b, weit, plz) {
    var ziel = b.handle ? profilAdresse(b, plz) : '';
    var gewerke = (b.gewerke || []).map(function (g) {
      return '<li class="inst-karte__gewerk">' + esc(GEWERKE[g] || g) + '</li>';
    }).join('');
    return '<article class="inst-karte' + (weit ? ' inst-karte--weit' : '') + '">' +
      '<div class="inst-karte__kopf">' +
        '<h3 class="inst-karte__firma">' + (ziel ? '<a href="' + esc(ziel) + '">' + esc(b.firma) + '</a>' : esc(b.firma)) + '</h3>' +
        (b.entfernung_km != null ? '<span class="inst-karte__entfernung">' + String(b.entfernung_km).replace('.', ',') + ' km</span>' : '') +
      '</div>' +
      '<p class="inst-karte__ort">' + esc(b.plz) + ' ' + esc(b.ort) + '</p>' +
      (b.handle ? '<p class="inst-google-kurz" data-inst-google-kurz="' + esc(b.handle) + '" hidden></p>' : '') +
            (gewerke ? '<ul class="inst-karte__gewerke">' + gewerke + '</ul>' : '') +
      '<div class="inst-karte__fuss">' +
        stufe(b.handwerkskarte_liegt_vor) +
        (ziel ? '<a class="button accent inst-karte__knopf" href="' + esc(ziel) + '#anfrage"><span>Angebot anfragen</span></a>' : '') +
      '</div>' +
    '</article>';
  }

/*
    Google-Bewertungen auf den Karten (Michel 21.09.2026): Sterne und Anzahl live
    per Sammelabfrage (google-bewertungen, { handles }); nichts wird gespeichert.
    Ergebnisse bleiben fuer diese Seite im Speicher, damit "Mehr laden" nicht neu fragt.
  */
  var GOOGLE_KURZ = {};
  function googleKurz(wurzel, url, key) {
    var felder = [].slice.call(wurzel.querySelectorAll('[data-inst-google-kurz]'));
    var zeigen = function (f) {
      var d = GOOGLE_KURZ[f.getAttribute('data-inst-google-kurz')];
      if (!d || !d.anzahl) return;
      var n = Math.round(d.bewertung * 2) / 2, s = '';
      for (var i = 1; i <= 5; i++) s += '<span class="inst-stern' + (i <= n ? ' inst-stern--an' : '') + '">★</span>';
      f.innerHTML = '<span class="inst-sterne" aria-hidden="true">' + s + '</span><strong>' + String(d.bewertung.toFixed(1)).replace('.', ',') + '</strong>' +
        '<span>(' + d.anzahl + ' Google-' + (d.anzahl === 1 ? 'Bewertung' : 'Bewertungen') + ')</span>';
      f.setAttribute('aria-label', String(d.bewertung.toFixed(1)).replace('.', ',') + ' von 5 Sternen, ' + d.anzahl + ' Bewertungen auf Google');
      f.hidden = false;
    };
    var offen = felder.map(function (f) { return f.getAttribute('data-inst-google-kurz'); })
      .filter(function (h, i, a) { return h && !(h in GOOGLE_KURZ) && a.indexOf(h) === i; });
    felder.forEach(zeigen);
    if (!offen.length || !url || !key) return;
    offen.forEach(function (h) { GOOGLE_KURZ[h] = null; });
    fetch(url + '/functions/v1/google-bewertungen', {
      method: 'POST', headers: { apikey: key, 'Content-Type': 'application/json' },
      body: JSON.stringify({ handles: offen.slice(0, 24) })
    }).then(function (r) { return r.json(); }).then(function (j) {
      var b = (j && j.bewertungen) || {};
      Object.keys(b).forEach(function (h) { GOOGLE_KURZ[h] = b[h]; });
      [].slice.call(wurzel.querySelectorAll('[data-inst-google-kurz]')).forEach(zeigen);
    }).catch(function () {});
  }

  function InstallateurSuche(wurzel) {
    this.wurzel = wurzel;
    this.url = (wurzel.getAttribute('data-supabase-url') || '').replace(/\/+$/, '');
    this.schluessel = wurzel.getAttribute('data-supabase-key') || '';
    this.form = wurzel.querySelector('[data-inst-form]');
    this.plzFeld = wurzel.querySelector('[data-inst-plz]');
    this.kmFeld = wurzel.querySelector('[data-inst-km]');
    this.fehler = wurzel.querySelector('[data-inst-fehler]');
    this.ergebnis = wurzel.querySelector('[data-inst-ergebnis]');
    if (!this.form || !this.ergebnis) return;

    var ich = this;
    this.form.addEventListener('submit', function (e) { e.preventDefault(); ich.suchen(); });

    // Postleitzahl aus der Adresse oder aus dem letzten Besuch uebernehmen.
    var ausAdresse = new URLSearchParams(location.search).get('plz');
    var gemerkt = null;
    try { gemerkt = window.localStorage.getItem('inst-plz'); } catch (x) {}
    var start = ausAdresse || gemerkt;
    if (start && /^[0-9]{5}$/.test(start)) {
      this.plzFeld.value = start;
      if (ausAdresse) this.suchen(true);
    }
  }

  InstallateurSuche.prototype.melden = function (text) {
    if (!this.fehler) return;
    this.fehler.textContent = text || '';
    this.fehler.hidden = !text;
  };

  InstallateurSuche.prototype.rpc = function (name, koerper) {
    return fetch(this.url + '/rest/v1/rpc/' + name, {
      method: 'POST',
      headers: { apikey: this.schluessel, 'Content-Type': 'application/json' },
      body: JSON.stringify(koerper)
    }).then(function (r) {
      if (!r.ok) throw new Error('http_' + r.status);
      return r.json();
    });
  };

  InstallateurSuche.prototype.suchen = function (still) {
    var ich = this;
    var plz = (this.plzFeld.value || '').trim();
    if (!/^[0-9]{5}$/.test(plz)) {
      this.melden('Bitte eine fünfstellige Postleitzahl eingeben.');
      this.plzFeld.focus();
      return;
    }
    if (!this.url || !this.schluessel) {
      this.melden('Die Suche ist gerade nicht erreichbar. Schreib uns an info@solaroutlet.de, wir suchen den Betrieb von Hand.');
      return;
    }
    this.melden('');
    try { window.localStorage.setItem('inst-plz', plz); } catch (x) {}
    if (!still) {
      var adresse = new URL(location.href);
      adresse.searchParams.set('plz', plz);
      history.replaceState(null, '', adresse);
    }

    var km = Number(this.kmFeld && this.kmFeld.value) || 50;
    this.ergebnis.hidden = false;
    this.ergebnis.innerHTML = '<p class="inst-ergebnis__laedt" role="status">Suche Betriebe in der Nähe …</p>';

    this.rpc('betriebe_im_umkreis_v3', { p_plz: plz, p_km: km })
      .then(function (treffer) {
        if (treffer && treffer.length) { ich.zeichnen(plz, km, treffer); return; }
        // Leerzustand: die naechsten Betriebe ueberhaupt dazuholen.
        return ich.rpc('betriebe_naechste_v3', { p_plz: plz, p_anzahl: 3 })
          .catch(function () { return []; })
          .then(function (naechste) { ich.zeichnen(plz, km, [], naechste || []); });
      })
      .catch(function () {
        ich.ergebnis.innerHTML = '<p class="inst-ergebnis__laedt">Die Suche hat gerade nicht geklappt. Bitte versuch es gleich noch einmal oder schreib uns an <a href="mailto:info@solaroutlet.de">info@solaroutlet.de</a>.</p>';
      });
  };

  InstallateurSuche.prototype.zeichnen = function (plz, km, treffer, naechste) {
    // Keine offene Anfrage an SolarOutlet mehr (Michel 21.09.2026): nur Betriebe.
    if (treffer.length) {
      var html = '<h2 class="inst-ergebnis__kopf">' +
        (treffer.length === 1 ? '1 Betrieb für ' : treffer.length + ' Betriebe für ') + esc(plz) +
        ' <span class="inst-karte__ort">im Umkreis von ' + km + ' km</span></h2>';
      html += '<div class="inst-liste">' + treffer.map(function (b) { return karte(b, false, plz); }).join('') + '</div>';
      this.ergebnis.innerHTML = html + SORTIERHINWEIS;
      googleKurz(this.ergebnis, this.url, this.schluessel);
      return;
    }
    var leer = '<div class="inst-leer">' +
      '<p class="inst-leer__titel">Im Umkreis von ' + km + ' km um ' + esc(plz) + ' haben wir noch keinen Betrieb.</p>' +
      '<p class="inst-leer__text">Vergrößere den Umkreis' + (naechste && naechste.length ? ' oder schau dir die nächsten Betriebe an.' : '.') + '</p>' +
    '</div>';
    if (naechste && naechste.length) {
      leer += '<h2 class="inst-ergebnis__kopf" style="margin-top:24px">Am nächsten dran, aber außerhalb des Gebiets</h2>' +
        '<p class="inst-karte__hinweis" style="margin-bottom:12px">Diese Betriebe liegen weiter weg, als sie üblicherweise fahren.</p>' +
        '<div class="inst-liste">' + naechste.map(function (b) { return karte(b, true, plz); }).join('') + '</div>';
    }
    this.ergebnis.innerHTML = leer;
    googleKurz(this.ergebnis, this.url, this.schluessel);
  };


  function start() {
    document.querySelectorAll('[data-inst-suche]').forEach(function (el) {
      if (!el.dataset.instBereit) { el.dataset.instBereit = '1'; new InstallateurSuche(el); }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
